import crypto from 'crypto';
import toPascalCase from 'to-pascal-case';

export let payload = {
  nodes: [],
  relationships: [],
  suggestions: []
};

let currentTemplate;
export function setTemplate(template) {
  currentTemplate = template;
}

export const SecurityZones = {
  PUBLIC: 0,
  PRIVATE: 1,
  parse: (str) => {
    if (typeof str === 'string') {
      if (str.match(/public/i)) {
        return SecurityZones.PUBLIC;
      }

      if (str.match(/private/i)) {
        return SecurityZones.PRIVATE;
      }

      throw new Error('Unrecognized zone was specified');
    }

    throw new Error('You must specify a string to be parsed');
  },
  toString: (zone) => {
    if (zone === SecurityZones.PUBLIC) {
      return 'Public';
    }

    if (zone === SecurityZones.PRIVATE) {
      return 'Private';
    }

    throw new Error('Unrecognized zone was specified');
  }
};

export default class Node {
  constructor(data, opts) {
    this.name = data.name || '';
    this.uniqueCompositeKey = data.uniqueCompositeKey || '';
    this.description = data.description || '';
    this.securityZone = data.securityZone || SecurityZones.PUBLIC;
    this.configuration = data.configuration || {};
    this.configurationHash = data.configurationHash || null;

    Object.defineProperty(this, 'entityId', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: currentTemplate.EntityID
    });

    Object.defineProperty(this, 'templateDataId', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: currentTemplate.TemplateDataID
    });

    Object.defineProperty(this, 'intel', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: {}
    });
  }

  getName() {
    return this.name;
  }

  setName(name) {
    this.name = name;
  }

  getUniqueCompositeKey() {
    return this.uniqueCompositeKey;
  }

  setUniqueCompositeKey(uniqueCompositeKey) {
    this.uniqueCompositeKey = uniqueCompositeKey;
  }

  getDescription() {
    return this.description;
  }

  setDescription(description) {
    this.description = description;
  }

  getSecurityZone() {
    return this.securityZone;
  }

  setSecurityZone(zone) {
    if (typeof zone === 'string') {
      if (zone.match(/public/i) || zone.match(/private/i)) {
        this.securityZone = zone.match(/public/i) ? SecurityZones.PUBLIC : SecurityZones.PRIVATE;
      } else {
        throw new Error(`Unrecognized zone of ${zone} was specified`);
      }
    } else if (typeof zone === 'number') {
      if (zone === SecurityZones.PUBLIC || zone === SecurityZones.PRIVATE) {
        this.securityZone = zone;
      } else {
        throw new Error('Unrecognized zone was specified');
      }
    }
  }

  getConfiguration() {
    return this.configuration;
  }

  setConfiguration(configuration) {
    this.configuration = configuration;
  }

  mergeConfiguration(configuration) {
    this.configuration = Object.assign(this.configuration, configuration);
  }

  getConfigurationHash() {
    return this.configurationHash;
  }

  setConfigurationHash(configurationHash) {
    this.configurationHash = configurationHash;
  }

  addIntelField(name, value) {
    const newName = `__${name.split('.').map(n => toPascalCase(n)).join('.')}`;
    this.intel[newName] = value;
    return newName;
  }

  appendNode(node) {
    // add this node type to the configuration
    // {
      // [NodeClass](s): []
    // }
  }

  serialize() {
    this.intel['__._RoarInternal.StartTime'] = global.startTime;
    this.intel['__._RoarInternal.SizeInBytes'] = Buffer.byteLength(JSON.stringify(Object.assign(this.intel, this.configuration)), 'utf8');

    return {
      EntityID: this.entityId,
      TemplateDataID: this.templateDataId,
      UniqueCompositeKey: this.uniqueCompositeKey,
      NodeClass: this.nodeClass,
      Name: this.name,
      Description: this.description,
      SecurityZone: SecurityZones.toString(this.securityZone),
      details: {
        Configuration: Object.assign(this.intel, this.configuration),
        ConfigurationHash: this.configurationHash ? this.configurationHash : crypto.createHash('sha256').update(JSON.stringify(this.configuration)).digest('hex')
      }
    };
  }
};
